import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue";
import { getAllTenantData } from '@/api/tenant';
import { ref } from 'vue';
import { useVModel } from '@vueuse/core';
export default {
  __name: 'index',
  props: {
    tenantId: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const value = useVModel(props);
    const options = ref([]);
    const loading = ref(false);
    const remoteMethod = async query => {
      if (query) {
        loading.value = true;
        const res = await getAllTenantData({
          keyword: query,
          isParent: 1
        });
        options.value = res.records.map(item => ({
          label: item.name,
          value: item.id
        }));
        loading.value = false;
      } else {
        options.value = [];
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_component_el_select, {
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        placeholder: "请选择租户",
        "remote-method": remoteMethod,
        loading: loading.value,
        style: {
          "width": "240px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "loading"]);
    };
  }
};